module.exports = __webpack_public_path__ + "static/media/mozilla.4741ffd6.png";